export enum StatusCodes {
  Ok = 200,
  Unauthorized = 401,
  NotFound = 404,
  InternalServerError = 500
}
